// @ts-nocheck
import Image1 from "../images/Categories/Kits.jpg";
import Image2 from "../images/Categories/Velas.jpg";
import Image3 from "../images/Categories/Decorativas.jpg";
import Image4 from "../images/Categories/Bordados.jpg";

export const categoriesOptions = [
  {
    title: "Kits Presenteaveis",
    imageSrc: Image1,
    imageAlt: "Imagem de kits presenteaveis",
    path: "/product-page/kits-presenteaveis",
  },
  {
    title: "Velas artesanais",
    imageSrc: Image2,
    imageAlt: "Imagem de um conjunto de velas",
    path: "/product-page/velas-artesanais",
  },
  {
    title: "Sabonetes decorativos",
    imageSrc: Image3,
    imageAlt: "Imagem de velas e sabonetes decorativos",
    path: "/product-page/cuidados-de-banho",
  },
  {
    title: "Bordados",
    imageSrc: Image4,
    imageAlt: "Imagem de joias e acessórios de resina",
    path: "/product-page/bordados",
  },
];
